<template>
  <div class="dbt db-toast" aria-live="polite" aria-relevant="additions">
    <transition-group name="dbt" tag="div" class="dbt-stack">
      <div
        v-for="n in lista"
        :key="n.id"
        class="dbt-item"
        :class="'is-' + n.tipo"
        :role="n.tipo === 'danger' ? 'alert' : 'status'"
        @mouseenter="pausar(n.id)"
        @mouseleave="reanudar(n.id)"
      >
        <span class="dbt-icon material-symbols-outlined">{{ iconos[n.tipo] || "info" }}</span>
        <div class="dbt-body">
          <p class="dbt-title">
            {{ n.titulo || titulos[n.tipo] }}
            <span v-if="n.veces > 1" class="dbt-count">×{{ n.veces }}</span>
          </p>
          <p class="dbt-msg">{{ n.mensaje }}</p>
          <ul v-if="n.detalles && n.detalles.length" class="dbt-details">
            <li v-for="(d, i) in n.detalles" :key="i">{{ d }}</li>
          </ul>
        </div>
        <button type="button" class="dbt-close" aria-label="Cerrar aviso" @click="cerrar(n.id)">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import {
  estadoNotificaciones,
  cerrarNotificacion,
  pausarNotificacion,
  reanudarNotificacion,
} from "@/directives/notificaciones.js";

export default {
  name: "DbToaster",
  data() {
    return {
      iconos: { success: "check_circle", danger: "error", warning: "warning", info: "info" },
      titulos: { success: "Hecho", danger: "Error", warning: "Atención", info: "Información" },
    };
  },
  computed: {
    lista() {
      return estadoNotificaciones.lista;
    },
  },
  methods: {
    cerrar: cerrarNotificacion,
    pausar: pausarNotificacion,
    reanudar: reanudarNotificacion,
  },
};
</script>

<style scoped>
/* Por encima de los modales de Bootstrap (1050-1060) */
.dbt {
  position: fixed;
  right: 20px;
  bottom: calc(20px + env(safe-area-inset-bottom, 0px));
  z-index: 2000;
  width: min(380px, calc(100vw - 32px));
  pointer-events: none;
}

.dbt-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dbt-item {
  --c: var(--sd-primary);
  --c-soft: var(--sd-primary-soft);
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 12px 14px 16px;
  border: 1px solid var(--sd-border);
  border-left: 4px solid var(--c);
  border-radius: 12px;
  background: var(--sd-surface);
  box-shadow: var(--sd-shadow-lg);
  font-family: var(--sd-font-body);
  text-align: left;
  pointer-events: auto;
}

.dbt-item.is-success {
  --c: var(--sd-success);
  --c-soft: var(--sd-success-soft);
}

.dbt-item.is-danger {
  --c: var(--sd-danger);
  --c-soft: var(--sd-danger-soft);
}

.dbt-item.is-warning {
  --c: var(--sd-warning);
  --c-soft: var(--sd-warning-soft);
}

.dbt-icon {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--c-soft);
  font-size: 20px;
  color: var(--c);
}

.dbt-body {
  flex: 1;
  min-width: 0;
}

.dbt-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--sd-text);
}

.dbt-count {
  padding: 0 6px;
  border-radius: 999px;
  background: var(--sd-surface-2);
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--sd-muted);
}

.dbt-msg {
  margin: 2px 0 0;
  font-size: 0.86rem;
  line-height: 1.45;
  color: var(--sd-muted);
  overflow-wrap: anywhere;
}

.dbt-details {
  margin: 6px 0 0;
  padding-left: 18px;
  font-size: 0.8rem;
  color: var(--sd-muted);
}

.dbt-close {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--sd-muted);
  cursor: pointer;
}

.dbt-close:hover {
  background: var(--sd-surface-2);
  color: var(--sd-text);
}

.dbt-close .material-symbols-outlined {
  font-size: 18px;
}

/* Animación */
.dbt-enter-active,
.dbt-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.dbt-enter,
.dbt-leave-to {
  opacity: 0;
  transform: translateX(24px);
}

.dbt-move {
  transition: transform 0.25s ease;
}

@media (prefers-reduced-motion: reduce) {
  .dbt-enter-active,
  .dbt-leave-active,
  .dbt-move {
    transition: none;
  }
}
</style>
